import { render } from "./gameAgents.vue?vue&type=template&id=0776ace0&scoped=true"
import script from "./gameAgents.vue?vue&type=script&lang=js"
export * from "./gameAgents.vue?vue&type=script&lang=js"

import "./gameAgents.vue?vue&type=style&index=0&id=0776ace0&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0776ace0"]])

export default __exports__